import { render, staticRenderFns } from "./LotDetailInEditList.vue?vue&type=template&id=2896e68b&scoped=true"
import script from "./LotDetailInEditList.vue?vue&type=script&lang=js"
export * from "./LotDetailInEditList.vue?vue&type=script&lang=js"
import style0 from "./LotDetailInEditList.vue?vue&type=style&index=0&id=2896e68b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896e68b",
  null
  
)

export default component.exports